import { Injectable } from '@angular/core';
import {Observable, interval, pipe, throwError, Subject} from 'rxjs';
import { HttpClient,HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import {environment} from "../../environments/environment";
import {JwtHelperService} from "@auth0/angular-jwt";
import {Router} from "@angular/router";
import {catchError, tap} from "rxjs/operators";
import {User} from "../shared/models/user.model";

import {LoggedinService} from "../loggedin.service";
import {LoggedinServiceBehavior} from "../loggedinbehavior.service";

//NGRX
import * as AuthActions from './store/auth.actions';
import * as fromApp from '../store/app.reducer';
import {Store} from "@ngrx/store";
import {RoleService} from "../role.service";

export interface Cognito  {
  AccessToken: string;
  ExpiresIn: string;
  IdToken: string;
  RefreshToken: string;
  TokenType: string;
}

export interface AuthResponseData {
  AccessToken: string;
  ExpiresIn: string;
  IdToken: string;
  RefreshToken: string;
  TokenType: string;
}

@Injectable({providedIn: 'root'})
export class AuthService {

  private domain = environment["API_URL"];
  private url = environment["API_URL"];
  user = new Subject<User>();
  private tokenExpirationTimer: any;

  constructor(private http: HttpClient,
              public jwtHelper: JwtHelperService,
              public router: Router,
              private loggedinService: LoggedinService,
              private loggedinServiceBehavior: LoggedinServiceBehavior,
              private roleService: RoleService,
              private store: Store<fromApp.AppState>) {
  }

  //never testes this
  getUser(): Observable<User> {
    return this.user.asObservable();
  } //end getUser

  roles(user_groups) {
    let role: string = '';
    if (user_groups.indexOf('superadmin') > -1) {
      //this.roleService.announceRole('superadmin');
      localStorage.setItem('role', 'superadmin')
      role = 'superadmin';
    }
    if (user_groups.indexOf('admin') > -1) {
      //this.roleService.announceRole('admin');
      localStorage.setItem('role', 'admin');
      role = 'admin';
    }
    return role;
  } //end roles

  handleAuthentication(AccessToken, IdToken, ExpiresIn, RefreshToken, TokenType){

    if (IdToken){
      const helper = new JwtHelperService();
      const decodedToken = helper.decodeToken(IdToken);
      const user_groups = decodedToken['cognito:groups']
      const my_role = this.roles(user_groups)




      const expirationDate = new Date(new Date().getTime() + decodedToken['exp']);
      const user = new User(decodedToken['sub'],
        decodedToken['cognito:username'],
        decodedToken['email'],
        my_role,
        RefreshToken,
        AccessToken,
        IdToken,
        expirationDate,
        decodedToken['exp']
      );
      localStorage.setItem('email', decodedToken['email']);
      localStorage.setItem('role', my_role);
      this.roleService.announceRole(my_role)

      this.loggedinService.announceLoggedin(true);
      this.loggedinServiceBehavior.announceLoggedin(true);
      console.log('dispatching user auth store',user)
      this.store.dispatch(new AuthActions.Login(user))


      let current_time = new Date().getTime() / 1000;
      let time_left = decodedToken['exp'] - current_time;
      this.autoLogout(time_left)
      localStorage.setItem('userData', JSON.stringify(user));
      console.log('userData created from service...');
      this.user.next(user);
      this.router.navigate(['/agencys']);
    } else {
      console.log('no IdToken from service');
    }
  } //end handleAuthentication

  logout() {
    this.user.next(null);
    localStorage.removeItem('userData');
    localStorage.removeItem('id_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('access_token');
    this.store.dispatch(new AuthActions.Logout())
    this.router.navigate(['/login']);
    if (this.tokenExpirationTimer) {
      clearTimeout(this.tokenExpirationTimer);
    }
    this.tokenExpirationTimer = null;
  } //end logout

  autoLogout(expirationDuration: number) {
    console.log('autoLogout called',expirationDuration);
    this.tokenExpirationTimer = setTimeout(() => {
      this.logout();
    }, expirationDuration*1000);
  } //end autoLogout

  private handleError(error: HttpErrorResponse) {

    console.log('xxxx',error.error);
    return throwError({message:error.error.message, status_code:error.status });

    // console.log('!!!!!!!!!!!',error);
    //
    //
    // // let errorMessage = 'An unknown error occurred!';
    // // if (!errorRes.error || !errorRes.error.message) {
    // //   return throwError(errorMessage);
    // // }
    // // switch (errorRes.error.message){
    // //   case 'User is disabled':
    // //     errorMessage = 'User is disabled';
    // //     break;
    // // }
    // // return throwError(errorMessage);
    //
    // if (error.error instanceof ErrorEvent) {
    //   // A client-side or network error occurred. Handle it accordingly.
    //   console.error('An error occurred:', error.error.message);
    // } else {
    //   // The backend returned an unsuccessful response code.
    //   // The response body may contain clues as to what went wrong,
    //   if (error.status && error.error.message){
    //     console.error(
    //       `Backend returned code ${error.status}, ` +
    //       `body was: ${error.error.message}`);
    //   }
    // }
    // // return an observable with a user-facing error message
    // if (error.status){
    //   console.log(error.status)
    //   return throwError({message:error.error.message, status_code:error.status });
    // } else {
    //   //console.error('no status code',error)
    // }
  }; //end handleError

  login(url: string, username: string, password: string){
    //{ headers: headers, params: params }
    return this.http.post<AuthResponseData>(url, {
      username: username,
      password: password
    },{  headers: { 'Content-Type': 'application/json'} }).pipe(
      tap(resData => {
        this.handleAuthentication(resData.AccessToken, resData.IdToken, resData.ExpiresIn, resData.RefreshToken, resData.TokenType);
      })
    );
  } //end login

  autoLogin() {
    //this.authSerivce.autoLogin();
    const userData:{
      uid: string,
      username: string,
      email: string,
      role: string,
      refresh_token: string,
      access_token: string,
      id_token: string,
      _tokenExpirationDate: string,
      exp: number
    } = JSON.parse(localStorage.getItem('userData'));
    if (!userData) {
      return;
    }
    const loadedUser = new User(userData.uid,
      userData.username,
      userData.email,
      userData.role,
      userData.refresh_token,
      userData.access_token,
      userData.id_token,
      new Date(userData._tokenExpirationDate),
      userData.exp
    );

    this.store.dispatch(new AuthActions.Login(loadedUser));

    console.log('loadedUser',loadedUser);
    if (loadedUser.IdToken) {
      this.user.next(loadedUser);
      //const expirationDuration = new Date(userData._tokenExpirationDate).getTime() - new Date().getTime();
      const helper = new JwtHelperService();
      const isExpired = helper.isTokenExpired(loadedUser.IdToken);
      if (isExpired){
        return;
      }
      let current_time = new Date().getTime() / 1000;
      const expirationDuration = loadedUser.exp - current_time;
      this.autoLogout(expirationDuration)
    }
  } //end autoLogin


} //end class
